import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { saveMemberLogo } from 'store/dispatchers/members.dispatchers';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import { connect } from 'react-redux';
import AlertDanger from 'components/UI/Alerts/AlertDanger';

function Avatar({
    src, alt, isLoading, saveAction, authMember,
})
{
    const [showPictureErrorDialog, setShowPictureErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [imageError, setImageError] = useState(false);

    const imageNotLoaded = () =>
    {
        setImageError(true);
    };

    const handleClick = () =>
    {
        inputRef.current.click();
    };

    const handleChange = async (e) =>
    {
        const fileReader = new FileReader();

        fileReader.readAsDataURL(e.target.files[0]);
        fileReader.onload = (event) =>
        {
            saveAction({
                logo_file: event.target.result,
                id: authMember.id,
            }).then((r) =>
            {
                if (r.response_code !== 200)
                {
                    if (r.messages && r.messages.length > 0)
                    {
                        setErrorMessage(r.messages[0]);
                    }
                    else
                    {
                        setErrorMessage('Error setting the profile picture, try again!');
                    }
                    setImageError(true);
                    setShowPictureErrorDialog(true);
                }
                setImageError(false);
            }).catch((err) =>
            {
                setImageError(true);
                setErrorMessage(err.message ?? err);
                setShowPictureErrorDialog(true);
            });
        };
    };

    const inputRef = useRef(null);

    return (
        <div className="tw-relative">
            <div
                className="tw-object-cover tw-bg-black tw-rounded-full tw-h-36 tw-w-36 tw-opacity-0 hover:tw-opacity-75 tw-z-20 tw-absolute tw-align-middle"
            >
                <input
                    accept="image/*"
                    type="file"
                    className="tw-hidden"
                    onChange={handleChange}
                    ref={inputRef}
                />
                <div
                    className="tw-w-full tw-h-full tw-flex tw-cursor-pointer"
                >
                    <button
                        type="button"
                        onClick={handleClick}
                        className="tw-w-full tw-h-full"
                    >
                        Change picture
                    </button>
                </div>
            </div>
            {!isLoading && !imageError ? (
                <img
                    onError={() =>
                    {
                        imageNotLoaded();
                    }}
                    alt={alt}
                    className="tw-object-cover tw-rounded-full tw-h-36 tw-w-36"
                    src={src}
                ></img>
            ) : (
                <img className="tw-object-cover tw-rounded-full tw-h-36 tw-w-36" src="/assets/img/user_placeholder.png" alt={alt} />
            )}
            <AlertDanger
                body={errorMessage}
                showDialog={showPictureErrorDialog}
                onAccept={() =>
                {
                    setShowPictureErrorDialog(false);
                }}
                onClose={() =>
                {
                    setShowPictureErrorDialog(false);
                }}
            />
        </div>
    );
}

Avatar.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    saveAction: PropTypes.func,
    authMember: PropTypes.object,
};

const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
    });
};
const mapDispatchToProps = (dispatch) => ({
    saveAction(data)
    {
        return dispatch(saveMemberLogo(data));
    },
});
export default connect(mapStateToProps, mapDispatchToProps)(Avatar);
